import { render, staticRenderFns } from "./statement_list.vue?vue&type=template&id=490dc7b6"
import script from "./statement_list.vue?vue&type=script&lang=js"
export * from "./statement_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports